import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTrackGeneratedShareUrl } from '@air/analytics';
import { ShortUrl } from '@air/api';
import { ShortUrlObjectType } from '@air/api/types';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getShortIdInformationKey } from '~/swr-hooks/shortUrl/useGetExistingShortIdInformation';
import { buildShareUrlGeneratedAnalyticsParams } from '~/utils/shortUrl/buildShareUrlGeneratedAnalyticsParams';

export const useGetShortIdForCanvas = () => {
  const queryClient = useQueryClient();
  const { trackGeneratedShareUrl } = useTrackGeneratedShareUrl();

  return useMutation({
    mutationFn: (params: Parameters<typeof ShortUrl.getShortIdForCanvas>[0]) => ShortUrl.getShortIdForCanvas(params),
    onSuccess: (data, params) => {
      queryClient.setQueryData(getShortIdInformationKey({ objectId: params.id, boardContext: undefined }), data);

      trackGeneratedShareUrl(
        buildShareUrlGeneratedAnalyticsParams({
          shareId: data.id,
          shortUrl: data,
          objectType: ShortUrlObjectType.canvas,
        }),
      );
    },
    onError: (error, params) => {
      throw reportErrorToBugsnag({
        error,
        context: 'Failed to get short id for canvas',
        metadata: { data: { params } },
      });
    },
  });
};
